import React, { useState } from 'react';
import { Trans } from '@ecg-internal/js-react-i18n';
import { Icon, Link } from '@hz-design-system/web-ui';
import { trackGAEvent } from '../../../../utils/gaTracking';

import Classes from './PopupLink.module.scss';

type TPopupLinkProps = {
  itemId: string;
};

let FlagAdIframe;

const PopupLink = ({ itemId }: TPopupLinkProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  const loadIframeComponent = async () => {
    FlagAdIframe = (await import(/* webpackChunkName: "FlagAdIframe" */ '../FlagAdIframe/FlagAdIframe')).default;
    setIsIframeLoaded(true);
  };

  const handleClick = () => {
    if (!isIframeLoaded) {
      trackGAEvent('TipAdClicked', itemId);
      loadIframeComponent();
    }
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Link onClick={handleClick}>
        <Icon name="alert" color="text-link-default" className={Classes.linkIcon} />
        <Trans i18nKey="flagging.title" tagName="span" className={Classes.linkText} />
      </Link>

      {isIframeLoaded && isOpen && <FlagAdIframe itemId={itemId} toggle={handleClick} />}
    </>
  );
};

export default PopupLink;
